import _typeof from "@babel/runtime/helpers/typeof";
import React from 'react';
/**
 * Suspense hoc component.
 *
 * @author Mikhail Siutsou
 * @function WithSuspense
 * @category Hocs
 * @param {ElementType | JSX.Element | null} Module function.
 * @return {JSX.Element} wrapped component.
 */

import { jsx as _jsx } from "react/jsx-runtime";

var WithSuspense = function WithSuspense(Module) {
  return /*#__PURE__*/_jsx(React.Suspense, {
    fallback: /*#__PURE__*/_jsx("span", {}),
    children: _typeof(Module) === 'object' ? Module : /*#__PURE__*/_jsx(Module, {})
  });
};

export { WithSuspense };